import { useTheme } from "@mui/material";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

interface MROIProps extends SvgIconProps {
  fill?: string;
}

export const MROI: React.FC<MROIProps> = ({ fill, ...props }) => {
  const theme = useTheme();
  const iconColor = fill || theme.palette.brandedTypography.textColor;

  return (
    <SvgIcon {...props} viewBox="0 0 20 20" sx={{ fill: "none" }}>
      <path
        d="M5 7.27022C5 7.10453 5.13431 6.97021 5.3 6.97021H6.7C6.86569 6.97021 7 7.10453 7 7.27022V15.6702C7 15.8359 6.86569 15.9702 6.7 15.9702H5.3C5.13431 15.9702 5 15.8359 5 15.6702V7.27022Z"
        fill={iconColor}
        stroke={iconColor}
      />
      <path
        d="M13 11.2702C13 11.1045 13.1343 10.9702 13.3 10.9702H14.7C14.8657 10.9702 15 11.1045 15 11.2702V15.6702C15 15.8359 14.8657 15.9702 14.7 15.9702H13.3C13.1343 15.9702 13 15.8359 13 15.6702V11.2702Z"
        fill={iconColor}
        stroke={iconColor}
      />
      <path
        d="M9 4.27022C9 4.10453 9.13431 3.97021 9.3 3.97021H10.7C10.8657 3.97021 11 4.10453 11 4.27021V15.6702C11 15.8359 10.8657 15.9702 10.7 15.9702H9.3C9.13431 15.9702 9 15.8359 9 15.6702V4.27022Z"
        fill={iconColor}
        stroke={iconColor}
      />
      <path
        d="M17 0.970215H3C1.89543 0.970215 1 1.86565 1 2.97021V16.9702C1 18.0748 1.89543 18.9702 3 18.9702H17C18.1046 18.9702 19 18.0748 19 16.9702V2.97021C19 1.86565 18.1046 0.970215 17 0.970215Z"
        stroke={iconColor}
      />
    </SvgIcon>
  );
};

export default MROI;
